export const SITE = {
  name: "AUT labs",
  phoneDisplay: "+91 93691 71717",
  phoneTel: "+919369171717",
  waNumber: "919369171717",
  waText: "Hi AUT labs: here's the job that eats our week: ",
  email: "hello@autlabs.in",
  area: "Bandra",
  location: "Mumbai, India",
  year: 2026,
  // 15-minute intro call. The free two-hour on-site audit is scheduled on this call.
  calLink: "teerth-shah-xh7vts/15min",
  calEmbed: "https://cal.com/teerth-shah-xh7vts/15min?embed=true&theme=light&layout=month_view",
  teamNames: ["Arya Shah", "Teerth Shah", "Urja Singhi"],
};

export const waLink = `https://wa.me/${SITE.waNumber}?text=${encodeURIComponent(SITE.waText)}`;
export const waLinkFor = (text) => `https://wa.me/${SITE.waNumber}?text=${encodeURIComponent(text)}`;

export const NAV = [
  { label: "Find your opportunities", to: "/find-opportunities" },
  { label: "What we build", to: "/what-we-build" },
  { label: "How we work", to: "/how-we-work" },
  { label: "Questions", to: "/questions" },
];
